import { Pipe, PipeTransform, inject } from '@angular/core';
import { IRegexService } from '@services/common/regex.service';

@Pipe({ name: 'regex' })
export class RegexPipe implements PipeTransform {
  private service = inject(IRegexService);
  transform(text: string): string {
    const regex = /\[(.*?)\]/g;
    return `${text}`.replace(regex, (match, key) => {
      return `${this.service.get(key)?.value}`;
    });
  }
}
